<div class="multiple-files-container" [title]="title">
    <span class="files" (click)="downloadFile(item)" *ngFor="let item of data; let last=last">
        <span class="filename">{{item.displayName}}</span><span *ngIf="!last">,&nbsp;</span>
    </span>
</div>